import React from 'react';
import PropTypes from 'prop-types';
import RenderAds from 'routes/home/components/desktop/RenderAds/RenderAds';
import AdCaller from 'helpers/ads/adCaller';
import Link from 'components/Link';
import s from './SponserAdSlot.scss';
class SponserAdSlot extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { data, alignClass, leftMargin } = this.props;

    //const DropdownComp = this.props.dropdownComp;
    const sponsoredAds = data && data.sponsoredAds ? data.sponsoredAds : '';
    const sponsoredTxt = data && data.sponsoredTxt ? data.sponsoredTxt : '';
    const sponseredLogo = data && data.sponseredLogo ? data.sponseredLogo : '';
    const sponsoredLink = data && data.sponsoredLink ? data.sponsoredLink : '';
    const navsponsoredAds = data;
    const navsponsoredTxt = data?.sponsoredTxt;
    if(data?.jname){
      return (
        <AdCaller
          data={data}
          immediateLoad
          adWapperClass={`${s.logoAd} ${alignClass ? s.leftAlign : ''}`}
        />
      );
    }
    return (
      <React.Fragment>
        {sponsoredAds &&
          sponsoredTxt &&
          !sponseredLogo &&
          !this.props.isPrime && (
            <div className={`${s.logoAd} ${alignClass ? s.leftAlign : ''}`}>
              <div className={s.adLogoText}>{sponsoredTxt}</div>
              <RenderAds
                adObject={sponsoredAds}
                immediateLoad
                isWapView={this.props.isWapView}
                noPlaceholder
              />
            </div>
          )}
        {navsponsoredAds &&
          alignClass &&
          !sponseredLogo &&
          !this.props.isPrime && (
            <div className={`${s.logoAd} ${alignClass ? s.leftAlign : ''}`}>
              {navsponsoredTxt && (
                <div className={s.adLogoText}>{navsponsoredTxt}</div>
              )}
              <RenderAds
                adObject={navsponsoredAds}
                immediateLoad
                isWapView={this.props.isWapView}
                noPlaceholder
              />
            </div>
          )}
        {sponseredLogo && (
          <div
            className={`${s.logoAd} ${alignClass ? s.leftAlign : ''} ${
              leftMargin ? s.leftMargin : ''
            }`}
          >
            {/* <div className={s.adLogoText}>{sponsoredTxt}</div> */}
            {sponsoredLink ? (
              <Link to={sponsoredLink} doNotChangeURL target="_blank">
                <img
                  src={`https://static.toiimg.com/photo/msid-${sponseredLogo}.cms`}
                  alt="Sponsored by"
                />
              </Link>
            ) : (
              <img
                src={`https://static.toiimg.com/photo/msid-${sponseredLogo}.cms`}
                alt="Sponsored by"
              />
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}
SponserAdSlot.propTypes = {
  data: PropTypes.shape({
    sponsoredTxt: PropTypes.string,
    sponsoredAds: PropTypes.string,
    sponsoredLink: PropTypes.string,
    sponsoredLogomsid: PropTypes.string,
    sponsoredClass: PropTypes.string,
  }),
  alignClass: PropTypes.bool,
};
SponserAdSlot.defaultProps = {
  alignClass: false,
  data: undefined,
};

export default SponserAdSlot;
